import { CSSProperties } from "react";
import { FCX, Tooltip, useUuid } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { IconInfoStokes } from "@icons";
import "./CategoryProfileSubtitle.styles.scss";

interface Props {
    tooltipText?: string;
    tooltipStyle?: CSSProperties;
}

const CategoryProfileSubtitle: FCX<Props> = ({
    children,
    className,
    testId,
    tooltipText,
    tooltipStyle,
}) => {
    const tooltipId = useUuid();

    return (
        <span className={cn("CategoryProfileSubtitle", className)} data-testid={testId}>
            <span className="CategoryProfileSubtitle__text">{children}</span>
            {tooltipText && (
                <>
                    <span
                        className="CategoryProfileSubtitle__info"
                        data-tooltip-id={tooltipId}
                    >
                        <IconInfoStokes width={18} height={18} />
                    </span>
                    <Tooltip
                        id={tooltipId}
                        place="top"
                        style={{ zIndex: 10, maxWidth: 340, ...tooltipStyle }}
                    >
                        {tooltipText}
                    </Tooltip>
                </>
            )}
        </span>
    );
};

export default CategoryProfileSubtitle;
